import * as S from "../../Style/Page/General.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleGeneral.js";
import HatPageTopLine from "../../Component/GeneralTopLine.js";
const History = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"일반사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/GeneralBusiness/introduce">
                <div className="kor">일반사업</div>
                <div className="eng">General Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"104px"}>
            <S.NavItem>
              <Link to="/GeneralBusiness/History">
                <div className="kor">주요사업이력</div>
                <div className="eng">Major business history</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/Introduce">
                  <div className="kor">일반사업소개</div>
                  <div className="eng">Miscellaneous Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"주요사업이력"} titleeng={"Miscellaneous Business / Major business history"}/>
            <S.HistoryTable class="history-table">
              <div class="history-table-head">
                <div class="history-table-ceil-small">
                  <div className="kor">구분</div>
                  <div className="eng">Year</div>
                </div>
                <div class="history-table-ceil-big">
                  <div className="kor">주요 사업내용</div>
                  <div className="eng">Major business history</div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1972</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)영안양행(구) 설립 (1972년~2000년) / 건물 임대업</div>
                    <div className="eng">Established YoungAn International Co.,Ltd.(former) (1972~2000) / Real estate lease business</div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1978</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">제지텍스 (1978년~1985년) / 챙심 원지 생산(재단 파품 재활용)</div>
                    <div className="eng">Jeji Tex (1978~1985) / Production of textiles for hat visor (utilizing cut fractions)</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1978</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">우진 (1978년~2009년) / 원단 재직 및 염색(모자 소량 원단 생산)</div>
                    <div className="eng">Woojin (1978~2009) / Fabrication and dyeing of textiles / Production of textiles used only a little for hats</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1979</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">김포공업사 (1979년~1984년) / 플라스틱 사출품 제조공장</div>
                    <div className="eng">Gimpo Industrial Co., Ltd. (1979~1984) / Production of plastic injection products</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1982</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)영안판지 (1982년~1987년) / 모자 수출용 포장박스 제조공장</div>
                    <div className="eng">YoungAn Cardboard Co.,Ltd. (1982~1987) / Production of package boxes for hat exports</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1991</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)세븐하이퍼 (1991년~2003년) / 유통 판매업 / 총 7개 점포 운영</div>
                    <div className="eng">Seven Hiper (1991~2003) / Distribution sales / operated a total of 7 stores</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1991</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)대륙기연 (1991년~1996년) / 모자 기계류 및 기타 기계류 생산</div>
                    <div className="eng">Daeryuk Kiyoun (1991~1996) / Production of hat machinery and other machinery</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1993</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)영안개발 (1993년~2004년) / 중고차 유통 판매</div>
                    <div className="eng">YoungAn Development Co., Ltd. (1993~2004) / Distribution and sales of used cars</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1994</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      중예(주) (1994년~2004년) / 중국 공예품 수입 판매 /
                      1987년부터 신세게백화점에서 중화인민공화국 공예품 전시 /
                      영안이 중국과의 민간 교류 첫 상품 수입 (스트로햇 연계로 관계 시작)
                    </div>
                    <div className="eng">
                      JoongYae Co., Ltd. (1994~2004) / Import and sales of Chinese craftworks
                      / Displayed Chinese craftworks at Shinsegae department store since 1987
                      / YoungAn performed the 1st product import from China via private sector exchanges
                      (The relationship was began via the straw hat business)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1997</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)스포츠아이콘 (1997년~2002년) / 스포츠 의류 생산 및 판매 / 2002년, (주)영안양행으로 상호 변경</div>
                    <div className="eng">Sports Icon Co., Ltd. (1997~2002) / Production and sales of sports clothing / Changed name in 2002 (Sports Icon Co.,Ltd. -> YoungAn International Co.,Ltd.)</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2001</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)알커뮤니케이션 (2001년~2014년) / 전화기 개발 및 판매</div>
                    <div className="eng">Al Communication Co., Ltd. (2001~2014) / Development and production/sales of phones</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2002</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">(주)다보컴 (2002년~2021년) / 환승장 3곳(여의도, 청량리, 구로) 광고사업</div>
                    <div className="eng">Dabocom (2002~2021) / Advertisement in public transportation transfer spots (Yeouido, Cheongnyang-ri and Guro)</div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2003</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">다보텔레콤(주) (2003년~2004년) / 전화기 제조</div>
                    <div className="eng">Dabo Telecom Co., Ltd. (2003~2004) / Production of phones</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2005</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">베레코 과테말라 S.A. (2005년~2006년) / 스포츠 의류 생산 및 판매</div>
                    <div className="eng">Vereco Guatemala S.A. (2005~2006) / Production and sales of sports clothing</div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2009</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">자일개발(주) 설립 / 종로 단성사 인수(2015년4월), 부동산 임대업</div>
                    <div className="eng">Established Zyle Development Co., Ltd. / Acquired Dansungsa in Apr. 2015 / Realestate lease business</div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2014</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">영안상사(주) 법인 전환 / 부동산 임대, 용역 사업</div>
                    <div className="eng">YoungAn Company Co., Ltd. Was converted into a corporation / Real estate lease business, Contract business</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2016</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">호명골드(주) 신규 설립 / 금 도매업</div>
                    <div className="eng">Established Homyoung Gold Co., Ltd. / Gold products wholesale</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2018</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">호명관광(주) / (주)모모커피와 커피숍 사업 동업 시작</div>
                    <div className="eng">Homyoung Tourism / Started a coffee shop business partnership with Momo Coffee Co., Ltd.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line last-line">
                <div class="history-table-ceil-small">2020</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">남영산업(주) 인수 / 제주 사이프러스CC 및 제주 남영목장 운영</div>
                    <div className="eng">
                      Acquired NamYeung Industrial Co., Ltd. / <br />
                      Operating Cypress Golf & resort and Namyeung farm in Jeju island
                    </div>
                  </div>
                </div>
              </div>
            </S.HistoryTable>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default History;
